import _ from 'lodash';
import platformUtils from './platformUtils';
import * as postMessage from './postMessage';
import reporter from './reporter';
import * as members from './privateMembers';

class Multilingual {
    constructor(appDefId){
        members._appDefId.set(this, appDefId);
    }

    get isEnabled() {
        return platformUtils.getRGI().getIsMultilingualEnabled();
    }

    get currentLanguage() {
        return platformUtils.getRGI().getCurrentLanguageCode();
    }

    get siteLanguages() {
        return platformUtils.getRGI().getSiteLanguages();
    }

    set currentLanguage(languageCode) {
        const languageCodes = this.siteLanguages.map((language) => language.languageCode);
        const isValidLanguageCode = _.includes(languageCodes, languageCode);

        return new Promise((resolve, reject) => {
            if (isValidLanguageCode) {
                const callback = (data, error) => { return error ? reject(error) : resolve(data); };
                postMessage.sendMessageToHost(
                    postMessage.Intent.WIX_CODE_SITE_API, {
                        command: postMessage.MessageTypes.ML_SET_LANGUAGECODE,
                        data: {languageCode},
                        appDefinitionId: members._appDefId.get(this),
                        callback
                    }
                );
            } else {
                reporter.reportSdkError(`Error: language code "${languageCode}" is invalid`);
                reject("invalid language code");
            }
        });
    }

}
export default Multilingual;

